import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import CreateReview from 'pages/Ai/Alerts/CreateReview';

import TextField from 'components/common/TextField/TextField';

import style from './Index.module.css';
import RequetsLists from './RequestLists';

const AiAssistenIndexPage = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>('');

  return (
    <div className={style.container}>
      <div className={style.header}>
        <h1>{t('aireview:AI_Document_Review')}</h1>
        <div>
          <TextField
            placeholder={t('aireview:Search')}
            value={search}
            onChange={val => setSearch(val.currentTarget.value)}
          />
        </div>
        <div>
          <CreateReview />
        </div>
      </div>
      <div>
        <RequetsLists />
      </div>
    </div>
  );
};

export default AiAssistenIndexPage;
